<template>
  <b-modal
      ref="update-team"
      hide-footer
      :title="'Modifier les équipes '"
      size="xl"
  >
    <div class="d-block">
      <b-container fluid>
        <div class="tab"> 
          <b-row>
            <b-col sm="3">
              <label>Bureau</label>
            </b-col>
            <b-col sm="9">
              <b-row>
                <b-button-group>
                  <b-button
                    variant="outline-primary"
                    v-for="(desk, name, index) in officeList" :key="index"
                    @click="selectOffice(name)"
                    :pressed="name == officeSelected"
                  >
                    {{name}}
                  </b-button>
                   <b-button variant="outline-primary" @click="addOffice()" :pressed="isAddingOffice">
                    Autre
                  </b-button>
                </b-button-group>
              </b-row>
              <br>
              <b-row v-if="isAddingOffice">
                <b-col sm="9">
                  <b-form-input type="text"
                    :formatter="formatterLower"
                    v-model="officeInput"
                  >
                  </b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-button variant="primary" @click="officeSelected = officeInput" :disabled="!officeInput">
                    <i class="fas fa-plus"></i>
                    Ajouter
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="officeSelected">
            <b-col sm="3">
              <label>Equipe</label>
            </b-col>
            <b-col sm="9">
              <b-row  v-if="!isAddingOffice">
                <b-button-group>
                  <b-button
                    variant="outline-primary"
                    v-for="(name, index) in teamList" :key="index"
                    @click="selectTeam(name)"
                    :pressed="name == teamSelected"
                  >
                  {{name}}
                  </b-button>
                  <b-button  variant="outline-primary" @click="addTeam()" :pressed="isAddingTeam">
                    Autre
                  </b-button>
                </b-button-group>
              </b-row>
              <br>
              <b-row v-if="isAddingTeam">
                <b-col sm="9">
                  <b-form-input type="text"
                    :formatter="formatterLower"
                    v-model="teamInput"
                  >
                  </b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-button variant="primary" @click="teamSelected = teamInput" :disabled="!teamInput">
                    <i class="fa fa-plus"></i>
                    Ajouter
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="teamSelected">
            <b-col sm="3">
              <label>Membre</label>
            </b-col>
            <b-col sm="9">
              <b-row  v-if="memberList.length !== 0">
                <b-button pill
                  variant="outline-danger"
                  v-for="(name, index) in memberList" :key="index"
                  @click="removeMember(name)"
                  style="margin-right: 1rem;"
                >
                  <i class="fa fa-times"></i>
                  {{name}}
                </b-button>
              </b-row>
              <br>
              <b-row>
                <b-col sm="9">
                  <b-input 
                    b-form-input type="text"
                    v-model="memberName"
                    placeholder="SGRI"
                    :formatter="formatterUpper"
                    maxlength="4"
                  ></b-input>
                </b-col>
                <b-col sm="3">
                  <b-button 
                    variant="primary"
                    @click="addMember()"
                  >
                    <i class="fa fa-plus"></i>
                    Ajouter
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <hr>
        <div style="overflow:auto;">
          <div style="float:right;">
            <b-button
              class="mt-3"
              variant="info"
              @click="save()"
            >
              Enregistrer
            </b-button>
          </div>
        </div>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'TeamsUpdateModal',
  props: ['offices'],
  data() {
    return {
      officeList: {},
      teamList: [],
      officeSelected: '', 
      teamSelected: '', 
      memberList: [],
      memberName: '', 
      isAddingOffice: false, 
      isAddingTeam: false,
      officeInput: '', 
      teamInput: '',
    }
  },
  methods: {
    formatterUpper(value) {
      return value.toUpperCase()
    },
    formatterLower(value) {
      return value.toLowerCase()
    },
    isEmpty (value) {
      return _.isEmpty(value)
    },
    hideModal () {
      this.cleanModal()
      this.$refs['update-team'].hide()
    },
    showModal () {
      this.cleanModal()
      this.officeList = this.offices
      this.$refs['update-team'].show()
    },
    save () {
      if (this.isAddingOffice) { 
        this.officeList[this.officeSelected] = {}
      }
      this.officeList[this.officeSelected][this.teamSelected] = this.memberList
      console.log(this.officeList)
      server
        .editOfficeTeams(this.officeList)
        .then(() => {
          this.$toasted.success('Liste modifiée!')
          this.hideModal()
          this.$emit('update-done')
        })
        .catch(() => {
          this.$toasted.error(`Une erreur est survenue. Veuillez réessayer plus tard`)
        })
    },
    selectOffice (office) {
      this.teamList = []
      this.memberList = []
      this.teamSelected = ''
      this.isAddingOffice = false
      this.officeSelected = office
      for (const team in this.officeList[this.officeSelected]){
        this.teamList.push(team)
      }
    },
    selectTeam (team) {
      this.memberList = []
      this.isAddingTeam = false
      this.teamSelected = team
      this.memberList = this.officeList[this.officeSelected][this.teamSelected]
    }, 
    removeMember (member) {
      for (let i = 0; i < this.memberList.length; i++) {
        if (this.memberList[i] === member) {
          this.memberList.splice(i, 1)
        }
      }
    },
    addMember () {
      this.memberList.push(this.memberName)
      this.memberName = ''
    },
    addOffice () {
      this.isAddingOffice = true
      this.isAddingTeam = true
      this.officeSelected = ''
      this.teamSelected = ''
      this.memberList = []
    },
    addTeam () {
      this.isAddingTeam = true
      this.teamSelected = ''
      this.memberList = []
    },
    cleanModal () {
      this.officeList = {}
      this.teamList = []
      this.officeSelected = '' 
      this.teamSelected = '' 
      this.memberList = []
      this.memberName = '' 
      this.isAddingOffice = false 
      this.isAddingTeam = false
    }
  },
};
</script>

<style>
input.invalid {
  background-color: #ffdddd;
}

</style>


// WEBPACK FOOTER //
// TeamsUpdateModal.vue?9e4dfbb0